const PREFIX = 'Components: Editor: share: ImageTile: elementToImage:';

async function elementToImage(_ref) {
  let {
    captureElement,
    fileType = 'png',
    pixelRatio = 1 // otherwise will use device's pixel ratio

  } = _ref;
  let dataUrl;

  try {
    dataUrl = await buildImage({
      captureElement,
      fileType,
      pixelRatio
    });
  } catch (err) {
    throw Error(`${PREFIX} buildImage failed: ${err}`);
  }

  if (!dataUrl) {
    throw Error(`${PREFIX} dataUrl is empty`);
  }

  return dataUrl;
}

export async function downloadImage(dataUrl, fileName) {
  // Download image (by click a download link)
  const link = document.createElement('a');
  link.download = fileName;
  link.href = dataUrl;
  link.click();
}
export default elementToImage;

const buildImage = async _ref2 => {
  let {
    captureElement,
    fileType,
    pixelRatio
  } = _ref2;
  let domToImage;

  try {
    domToImage = await loadDomToImage(fileType);
  } catch (err) {
    throw Error(`${PREFIX} failed to lazy-load domToImage: ${err}`);
  }

  try {
    return domToImage(captureElement, {
      scale: pixelRatio
    });
  } catch (err) {
    throw Error(`${PREFIX} domToImage failed: ${err}`);
  }
}; // Lazy-load domToImage based on fileType


const loadDomToImage = async fileType => {
  let domToImage;

  switch (fileType) {
    case 'png':
      domToImage = await import('modern-screenshot').then(mod => mod.domToPng);
      break;

    case 'jpg':
      domToImage = await import('modern-screenshot').then(mod => mod.domToJpeg);
      break;

    case 'webp':
      domToImage = await import('modern-screenshot').then(mod => mod.domToWebp);
      break;

    default:
      throw Error(`${PREFIX} unknown fileType: ${fileType}`);
  }

  return domToImage;
};